export const telegram = {
  "queries.useTelegramAuth.error": "Произошла ошибка",
};
